import React from 'react'
import Afiliate from '@/assets/store/icon/icon-affiliate.svg'
import Button from '@/shared/components/ui/Button';
import { ExternalLink } from 'lucide-react';
interface CardAffiliateProps {
    nominal?: number;
    totalClick?: number;
    onClick?: () => void;
}

const CardAffiliate = ({ nominal = 0, totalClick = 0, onClick }: CardAffiliateProps) => {
    const formattedNominal = new Intl.NumberFormat('id-ID').format(nominal);

    return (
        <article className="shadowCard p-3 inline-flex gap-3 justify-between items-center">
            <div className="min-w-0 inline-flex gap-3 items-center">
                <figure className="overflow-hidden shrink-0">
                    <img
                        src={Afiliate}
                        alt="icon affiliate"
                        className="w-auto h-auto object-cover"
                        loading="eager"
                    />
                </figure>
                <div className="min-w-0">
                    <p className="truncate title2medium capitalize">Dashboard Affiliate</p>
                    <p className="truncate reg12 text-text-grey capitalize">
                        Komisi Rp {formattedNominal} • {totalClick} Klik
                    </p>
                </div>
            </div>
            <Button onClick={onClick} customButton='btn-fill-blue'>
                <ExternalLink />
                <span className='title3'>Akses</span>
            </Button>
        </article>
    );
};

export default CardAffiliate;